"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var VariationAttributes = function VariationAttributesComponent(_ref) {
  var customClassNamePrefix = _ref.customClassNamePrefix,
      variationAttributes = _ref.variationAttributes;

  if (!variationAttributes) {
    return null;
  }

  return variationAttributes.map(function (attribute) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(customClassNamePrefix, "__attribute"),
      key: attribute.id
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "".concat(customClassNamePrefix, "__attribute-key")
    }, attribute.displayName), /*#__PURE__*/_react["default"].createElement("span", {
      className: "".concat(customClassNamePrefix, "__attribute-value")
    }, attribute.displayValue));
  });
};

VariationAttributes.propTypes = {
  customClassNamePrefix: _propTypes["default"].string,
  variationAttributes: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired
};
VariationAttributes.defaultProps = {
  customClassNamePrefix: 'variation-attributes'
};
var _default = VariationAttributes;
exports["default"] = _default;